import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import { FaEye, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaClipboardList, FaEllipsisV } from "react-icons/fa";
import axios from "axios";
import useAuth from "../dashboard/useAuth";
import Sidebar from "../dashboard/sidebar";
import Navbar from "../dashboard/navbar";

const Remboursement = ({ titre }) => {
    useAuth();
    const [remboursements, setRemboursements] = useState([]);
    const [selectedRemboursement, setSelectedRemboursement] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: "date_remboursement", direction: "descending" });
    const [searchTerm, setSearchTerm] = useState("");
    const [filtreStatut, setFiltreStatut] = useState("tous");
    const [alert, setAlert] = useState({ message: "", type: "" });
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [accesGroupe, setAccesGroupe] = useState([]);
    const user_id = localStorage.getItem("IDDDD");
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [selectedMotif, setSelectedMotif] = useState("");
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectComment, setRejectComment] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => {
        if (user_id) {
            document.title = "PayMe | Remboursements";
            verifGroupe();
            fetchRemboursements();
        }
    }, [user_id]);

    const fetchRemboursements = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/liste-remboursements-utilisateur/${user_id}/`);
            console.log("Données complètes reçues:", response.data);

            if (response.data && response.data.status === 'success' && Array.isArray(response.data.remboursements)) {
                setRemboursements(response.data.remboursements);
            } else {
                console.error("Structure de données inattendue:", response.data);
                setRemboursements([]);
                showAlert("Format de données incorrect", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            setRemboursements([]);
            showAlert("Erreur lors du chargement des remboursements", "danger");
        }
    };


    const verifGroupe = async () => {
        const groupe = localStorage.getItem("groupe");
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
            if (response.status === 200) {
                const cleanedAccessArray = response.data.acces
                    .map(item => item.acces ? item.acces.replace(/[\[\]']/g, "").trim().split(",").map(access => access.trim()) : [])
                    .flat();
                setAccesGroupe(cleanedAccessArray);
                localStorage.setItem("accesGroupe", JSON.stringify(cleanedAccessArray));
            }
        } catch (error) {
            console.error('Erreur lors de la vérification du groupe', error);
        }
    };

    // if (!accesGroupe.includes("Produits")) {
    //     return null;
    // }

    const handleDeleteRemboursement = async () => {
        if (selectedRemboursement) {
            try {
                await axios.delete(`${process.env.REACT_APP_HOTE}/supprimer-remboursement/${selectedRemboursement.remboursement_id}/`);
                showAlert("Remboursement supprimé avec succès !");
                fetchRemboursements();
            } catch (error) {
                console.error("Erreur lors de la suppression", error);
                showAlert("Erreur lors de la suppression", "danger");
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    const showAlert = (message, type = "success") => {
        setAlert({ message, type });
        setTimeout(() => setAlert({ message: "", type: "" }), 3000);
    };

    const handleSort = (key) => {
        setSortConfig({
            key,
            direction: sortConfig.key === key && sortConfig.direction === "ascending" ? "descending" : "ascending"
        });
    };

    const filteredRemboursements = remboursements.filter(remboursement => {
        const matchesSearch =
            remboursement.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
            remboursement.nom_produit.toLowerCase().includes(searchTerm.toLowerCase()) ||
            remboursement.transaction_id.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesStatus = filtreStatut === "tous" || remboursement.status === filtreStatut;

        return matchesSearch && matchesStatus;
    });

    const sortedRemboursements = [...filteredRemboursements].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "ascending" ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "ascending" ? 1 : -1;
        return 0;
    });

    const indexOfLastRemboursement = currentPage * itemsPerPage;
    const indexOfFirstRemboursement = indexOfLastRemboursement - itemsPerPage;
    const currentRemboursements = sortedRemboursements.slice(indexOfFirstRemboursement, indexOfLastRemboursement);
    const totalPages = Math.ceil(sortedRemboursements.length / itemsPerPage);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(amount);
    };

    const handleShowDetails = (remboursement) => {
        if (!remboursement) return;
        setSelectedRemboursement(remboursement);
        setSelectedMotif(remboursement.motif);
        setShowDetailModal(true);
    };


    const handleApprove = async () => {
        if (!selectedRemboursement) return;

        if (window.confirm(`Êtes-vous sûr de vouloir rembourser ${formatCurrency(selectedRemboursement.total)} à ${selectedRemboursement.client} ?`)) {
            setIsProcessing(true);

            try {
                const refundResponse = await axios.post(
                    `${process.env.REACT_APP_HOTE}/refund-transaction/`,
                    {
                        transaction_id: selectedRemboursement.transaction_id,
                        amount: selectedRemboursement.total,
                        remboursement_id: selectedRemboursement.remboursement_id,
                    }
                );

                if (refundResponse.data.success) {
                    // Attendre un peu pour permettre au webhook de traiter
                    await new Promise(resolve => setTimeout(resolve, 2000));

                    // Rafraîchir les données
                    await fetchRemboursements();
                    showAlert("Remboursement initié avec succès ! Le statut sera mis à jour sous peu.");
                } else {
                    throw new Error(refundResponse.data.message || "Échec du remboursement");
                }
            } catch (error) {
                console.error("Erreur lors du remboursement:", error);
                showAlert(`Erreur: ${error.response?.data?.message || error.message}`, "danger");
            } finally {
                setIsProcessing(false);
                setShowDetailModal(false);
            }
        }
    };


    const handleReject = async () => {
        setShowRejectModal(true);
    };

    const confirmReject = async () => {
        try {
            const formData = new FormData();
            formData.append('comment', rejectComment);

            await axios.put(`${process.env.REACT_APP_HOTE}/rejeter-remboursement/${selectedRemboursement.remboursement_id}/`,
                { comment: rejectComment },
                {
                    headers: { 'Content-Type': 'application/json' }
                }
            );
            showAlert("Demande de remboursement rejetée avec succès !");
            fetchRemboursements();
            setShowDetailModal(false);
            setShowRejectModal(false);
            setRejectComment("");
        } catch (error) {
            console.error("Erreur lors du rejet", error);
            showAlert("Erreur lors du rejet", "danger");
        }
    };


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h2 className="d-flex align-items-center">
                            <FaClipboardList size={25} className="mr-2" /> Gestion des remboursements
                        </h2>
                        <small>Suivi des demandes de remboursements.</small>
                    </div>
                </div>

                <div className="mt-4">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-2">
                        <h5>Liste des remboursements</h5>
                        <div className="d-flex flex-column flex-sm-row flex-wrap mt-3 mt-md-0" style={{ gap: "10px" }}>
                            <div className="d-flex">
                                <button
                                    className={`btn mr-2 ${selectedRemboursement ? "btn-success" : "btn-default text-dark"}`}
                                    disabled={!selectedRemboursement}
                                    onClick={() => selectedRemboursement && handleShowDetails(selectedRemboursement)}
                                >
                                    <FaEye /> Examiner
                                </button>
                            </div>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`alert alert-${alert.type}`}>{alert.message}</div>
                    )}

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: "10px" }}>
                                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                            <select
                                                className="form-select bg-default p-1"
                                                style={{
                                                    width: "auto",
                                                    border: "1px black solid",
                                                    borderRadius: "5px",
                                                }}
                                                value={itemsPerPage}
                                                onChange={(e) => {
                                                    setItemsPerPage(Number(e.target.value));
                                                    setCurrentPage(1);
                                                }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={20}>20</option>
                                                <option value={50}>50</option>
                                            </select>

                                            {/* <select
                                                className="form-select bg-default p-1"
                                                style={{
                                                    width: "auto",
                                                    border: "1px black solid",
                                                    borderRadius: "5px",
                                                }}
                                                value={filtreStatut}
                                                onChange={(e) => setFiltreStatut(e.target.value)}
                                            >
                                                <option value="tous">Tous les statuts</option>
                                                <option value="Terminé">Terminé</option>
                                                <option value="Échoué">Échoué</option>
                                                <option value="En attente">En attente</option>
                                            </select> */}
                                        </div>

                                        <input
                                            type="text"
                                            placeholder="Rechercher..."
                                            className="form-control"
                                            style={{ maxWidth: "150px", width: "100%" }}
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>

                                    <div className="table-responsive">
                                        <table
                                            className="footable table table-stripped footable-loaded tablet breakpoint"
                                            data-page-size="8"
                                            data-filter="#filter"
                                            style={{ fontSize: "12px" }}
                                        >
                                            <thead>

                                                <tr>
                                                    <th
                                                        className="text-secondary text-wrap  d-none d-md-table-cell"
                                                        onClick={() => handleSort("date_remboursement")}
                                                        style={{ width: "13%", minWidth: "100px" }}
                                                    >
                                                        Date demande
                                                        {sortConfig.key === "date_remboursement"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell  align-middle"
                                                        onClick={() => handleSort("client")}
                                                        style={{ width: "12%", minWidth: "150px" }}
                                                    >
                                                        Client
                                                        {sortConfig.key === "client"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell  align-middle"
                                                        onClick={() => handleSort("produit")}
                                                        style={{ width: "10%", minWidth: "80px" }}
                                                    >
                                                        Produit
                                                        {sortConfig.key === "produit"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center  align-middle"
                                                        onClick={() => handleSort("montant")}
                                                        style={{ width: "11%", minWidth: "80px" }}
                                                    >
                                                        Montant
                                                        {sortConfig.key === "montant"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap text-center d-none d-md-table-cell"
                                                        onClick={() => handleSort("transcation_id")}
                                                        style={{ width: "11%", minWidth: "100px" }}
                                                    >
                                                        Transaction
                                                        {sortConfig.key === "transaction_id"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>

                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                                        onClick={() => handleSort("statut")}
                                                        style={{ width: "12%", minWidth: "80px" }}
                                                    >
                                                        statut
                                                        {sortConfig.key === "statut"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell"
                                                        onClick={() => handleSort("motif")}
                                                        style={{ width: "15%", minWidth: "100px" }}
                                                    >
                                                        Motif
                                                        {sortConfig.key === "motif"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentRemboursements && currentRemboursements.length > 0 ? (
                                                    currentRemboursements.map((remboursement) => (
                                                        <tr
                                                            key={remboursement.remboursement_id}
                                                            onClick={() => {
                                                                // Si la ligne est déjà sélectionnée, on la désélectionne
                                                                if (selectedRemboursement?.remboursement_id === remboursement.remboursement_id) {
                                                                    setSelectedRemboursement(null);
                                                                } else {
                                                                    setSelectedRemboursement(remboursement);
                                                                }
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                            className={`bg-white ${selectedRemboursement?.remboursement_id === remboursement.remboursement_id ? "bg-success text-white" : ""}`}
                                                        >

                                                            <td
                                                                className="d-none d-md-table-cell  align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span>{remboursement.date_demande}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell  align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className="fw-semibold">{remboursement.client}</span>
                                                            </td>
                                                            <td
                                                                className=""
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className="fw-semibold">{remboursement.produit}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className="fw-semibold">{formatCurrency(remboursement.total)}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}>
                                                                <div className="fw-semibold">{remboursement.transaction_id}</div>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <div className={`badge fw-semibold ${remboursement.statut === "Acheté"
                                                                    ? "bg-success text-white"
                                                                    : remboursement.statut === "En traitement"
                                                                        ? "bg-warning text-dark"
                                                                        : remboursement.statut === "Rejeté"
                                                                            ? "bg-danger text-white"
                                                                            : remboursement.statut === "Remboursé"
                                                                                ? "bg-success text-white"
                                                                                : "bg-secondary text-white"
                                                                    }`}>
                                                                    {remboursement.statut}
                                                                </div>
                                                            </td>
                                                            <td className="d-none d-md-table-cell align-middle" style={{ padding: "0.5rem", maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
    <div className="fw-semibold">{remboursement.motif}</div>
</td>

                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="8" className="text-center">
                                                            Aucun remboursement trouvé
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Pagination Controls */}
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div className="dataTables_info" role="status" aria-live="polite">
                                            {sortedRemboursements.length === 0
                                                ? "Aucun élément à afficher"
                                                : `Élément ${indexOfFirstRemboursement + 1} à ${Math.min(indexOfLastRemboursement, sortedRemboursements.length)} sur ${sortedRemboursements.length}`}
                                        </div>

                                        <div>
                                            {Array.from({ length: totalPages }, (_, index) => (
                                                <button
                                                    key={index + 1}
                                                    onClick={() => setCurrentPage(index + 1)}
                                                    className={`btn ${currentPage === index + 1 ? "btn-default" : "btn-light"
                                                        } mx-1`}
                                                >
                                                    {index + 1}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Modal pour afficher les détails du motif */}
            <Modal 
    show={showDetailModal} 
    onHide={() => setShowDetailModal(false)} 
    centered
    size="md"
>
    <Modal.Header  className="border-bottom-0 pb-0">
        <Modal.Title className="h4 text-primary">Détails du remboursement</Modal.Title>
    </Modal.Header>
    <Modal.Body className="pt-1">
        <div className="mb-4 p-3 bg-light rounded">
            <div className="d-flex justify-content-between mb-2">
                <span className="font-weight-bold">Client:</span>
                <span>{selectedRemboursement?.client}</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
                <span className="font-weight-bold">Produit:</span>
                <span>{selectedRemboursement?.produit}</span>
            </div>
            <div className="d-flex justify-content-between">
                <span className="font-weight-bold">Montant:</span>
                <span className="text-success">
                    {selectedRemboursement && formatCurrency(selectedRemboursement.total)}
                </span>
            </div>
        </div>

        <div className="form-group mt-4">
            <label className="h5 mb-3">Motif de remboursement:</label>
            <div className="p-3 bg-light rounded" style={{ minHeight: '100px' }}>
                {selectedMotif || <span className="text-muted">Aucun motif fourni</span>}
            </div>
        </div>
    </Modal.Body>
    <Modal.Footer className="border-top-0 pt-0">
        <Button 
            variant="secondary" 
            onClick={() => setShowDetailModal(false)}
            className="px-4"
        >
            Fermer
        </Button>
        <Button 
            variant="danger" 
            onClick={handleReject}
            className="px-4"
            disabled={isProcessing || selectedRemboursement?.statut !== 'En traitement'}
        >
            Rejeter
        </Button>
        <Button
            variant="primary"
            onClick={handleApprove}
            disabled={isProcessing || selectedRemboursement?.statut !== 'En traitement'}
            className="px-4"
        >
            {isProcessing ? (
                <>
                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                    Traitement...
                </>
            ) : 'Approuver'}
        </Button>
    </Modal.Footer>
</Modal>

            {/* Nouveau Modal pour la confirmation de rejet */}
            <Modal show={showRejectModal} onHide={() => setShowRejectModal(false)} centered >
                <Modal.Header >
                    <Modal.Title>Confirmer le rejet</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="rejectComment">
                        <Form.Label>Veuillez saisir un commentaire pour le rejet :</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={rejectComment}
                            onChange={(e) => setRejectComment(e.target.value)}
                            placeholder="Motif du rejet..."
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {
                        setShowRejectModal(false);
                        setRejectComment("");
                    }}>
                        Annuler
                    </Button>
                    <Button
                        variant="danger"
                        onClick={confirmReject}
                        disabled={!rejectComment.trim()}
                    >
                        Confirmer le rejet
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Remboursement;